export default {
  meta: {
    title: '周报详情',
    url: '/abside/weekdetail', // 埋点字段，上报归属的模块
    urlName: 'ab侧-周报详情', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
